import React from 'react';
import { Badge, Box, Flex, Heading, Switch, Text } from '@chakra-ui/react';

/**
 * EG-70 — plano do grupo (company_group.is_freemium). Mesma receita visual do
 * EsgStarterCard (faixa esquerda + badge mudam com o estado), mas sem ação
 * assíncrona própria: é estado persistido, editado junto do resto do
 * formulário e gravado no mesmo submit.
 *
 * Switch representa "é cliente pago?" (marcado = cliente, is_freemium=false) —
 * não "é freemium?" — porque promover pra cliente é a ação que o admin faz de
 * propósito; deixar desmarcado (freemium) é o estado de repouso, igual ao
 * default da coluna.
 */
export default function FreemiumCard({ value, onChange }) {
 const isClient = value === false;

 return (
  <Box
   mt='24px'
   bg='white'
   borderRadius='12px'
   border='1px solid #E5E5E5'
   borderLeft={`4px solid ${isClient ? '#0073BB' : '#D7DBE0'}`}
   p='20px'
   transition='0.15s'
  >
   <Flex justify='space-between' align='center' gap='12px'>
    <Flex align='center' gap='10px' wrap='wrap'>
     <Heading fontSize='16px'>Plano</Heading>
     <Badge
      borderRadius='full'
      px='8px'
      py='1px'
      fontSize='10px'
      textTransform='none'
      color={isClient ? '#1F7A33' : '#5C6066'}
      bg={isClient ? '#E3F5E8' : '#EDEFF2'}
     >
      {isClient ? 'Cliente' : 'Freemium'}
     </Badge>
    </Flex>

    <Switch
     colorScheme='blue'
     isChecked={isClient}
     onChange={(e) => onChange(!e.target.checked)}
    />
   </Flex>

   <Text fontSize='sm' color='#5C6066' mt='8px'>
    {isClient
     ? 'Cliente — acesso completo a Relatórios e Aulas e Materiais.'
     : 'Freemium — Relatórios e Aulas e Materiais aparecem bloqueados, com chamada para upgrade.'}
   </Text>
  </Box>
 );
}
